import styled, { css } from 'styled-components';
import { Flex } from '../Flex/Flex.js';

const Divider = styled(Flex).attrs({ role: 'separator' })(({ theme: { olist: { components: { divider }, }, }, }) => css `
    border-top-width: 1px;
    border-bottom-width: 0;
    border-color: ${divider.color};
    border-style: solid;
    width: 100%;

    margin-top: ${divider['margin-top']};
    margin-bottom: ${divider['margin-bottom']};
  `);

export { Divider };
